module.exports = __webpack_public_path__ + "static/img/saesenthessis.730701e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/scoiatael/saesenthessis.png
// module id = VXF7
// module chunks = 0